import { faPen, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import 'components/desktop/_general/ListItem/ListItem.scss';

interface IProps {
	text: string;
	title?: string | null;
	iconSvgUrl?: string | null;
	textColor?: string;
	backgroundColor?: string;
	handleDelete?: () => void;
	handleEdit?: () => void;
}

const ListItem = (props: IProps) => {
	const { t } = useTranslation();
	const getTitle = () => {
		if (props.title) {
			return props.title;
		}
	};

	const handleDelete = async () => {
		if (!props.handleDelete) return;
		const result = await Swal.mixin({
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: t('_general:DELETE'),
			cancelButtonText: t('_general:CANCEL'),
			customClass: {
				confirmButton: 'btn btn-danger',
				cancelButton: 'btn btn-primary',
				closeButton: 'alert-danger',
				container: 'z-index-5000',
			},
		}).fire({
			text: t('user:DELETE_DIALOG'),
			icon: 'warning',
		});
		if (result.isConfirmed) {
			props.handleDelete();
		}
	};

	return (
		<div className="list-item-component">
			<div
				className="d-flex flex-row align-items-center"
				style={props.backgroundColor ? { backgroundColor: '#efefef' } : {}}
				title={getTitle()}
			>
				{props.iconSvgUrl && (
					<img
						src={props.iconSvgUrl ?? ''}
						style={{
							width: '24px',
							height: '24px',
							marginRight: '13px',
						}}
					/>
				)}
				<div className="flex-grow-1" style={{ color: props.textColor }}>
					{props.title && (
						<div className="list-item-component-category">{props.title}</div>
					)}
					<div className="list-item-component-text">{props.text}</div>
				</div>
				{props.handleEdit && (
					<FontAwesomeIcon
						className="list-item-component-svg-small"
						icon={faPen}
						onClick={props.handleEdit}
					/>
				)}
				{props.handleDelete && (
					<FontAwesomeIcon
						className="list-item-component-svg-small"
						icon={faTrashCan}
						onClick={handleDelete}
					/>
				)}
			</div>
		</div>
	);
};

export default ListItem;
